import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";

import { Footer } from "../components/Footer";
import { Header } from "../components/Header";

export function NotFoundPage() {
  const { t } = useTranslation(["landing", "common"]);

  return (
    <Box>
      <Header />
      <Box
        component="main"
        sx={{
          minHeight: "70vh",
          display: "flex",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Container maxWidth="sm">
          <Stack spacing={3} alignItems="center">
            <Typography variant="overline" color="primary" sx={{ letterSpacing: 4 }}>
              404
            </Typography>
            <Typography variant="h3" component="h1">
              {t("landing:notFound.title")}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {t("landing:notFound.description")}
            </Typography>
            <Button component={RouterLink} to="/" variant="contained" size="large">
              {t("common:actions.backHome")}
            </Button>
          </Stack>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
}
